// import Vue from 'vue'
// import Vuex from 'vuex'
import router from '@/router'
import { generateRoutes } from '@/utils/routeGenerator'
import {menuNav} from "@/axios/http";

export default {
  state: {
    permissions:[] , //  权限标识
    menuList:[],     //  当前所选系统的菜单
    userInfo:null,
    hasRoute: false

  },
  actions:{

    async loadDynamicRoutes({ commit, state }) {
      if (state.hasRoute) return

       // 拉菜单
      menuNav().then(res=>{
     /*   const asyncRoutes = generateRoutes(res.data.menus)
        asyncRoutes.concat([
          {
            path:'homePage',
            name:"homePage",
            component:() => import(`@/view/home.vue`),
          }
        ])
        console.log(asyncRoutes)

        let mainRoutes = [
          {
            path: '/main',
            name: 'main',
            component:() => import(`@/view/main.vue`),
            children:asyncRoutes
          }
        ]
        console.log(mainRoutes)
        router.addRoute(mainRoutes)*/

        commit('updateMenuList', res.data.menus)
        commit('updatePermissions', res.data.permissions)
      })
      // const asyncRoutes = generateRoutes(res.data)
      //
      // asyncRoutes.forEach(route => {
      //   router.addRoute(route)
      // })

      // commit('setHasRoute', true)
    }
  },
  mutations: {
    setHasRoute(state, status) {
      state.hasRoute = status
    },
    updatePermissions(state, value) {
      state.permissions = value
    },
    updateMenuList(state, value) {
      state.menuList = value
    },
    updateUserInfo(state, value) {
      state.userInfo = value
    },
  }
}
